import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_EditableTest } from './ModuleFE_EditableTest.js';
import { DBItemDropDownMultiSelector } from '../../components/_TS_MultiSelect/DBItemDropDownMultiSelector.js';
import { GenericDropDownV3 } from '../../components/GenericDropDown/index.js';
import { TS_MultiSelect_V2 } from '../../components/TS_MultiSelect/index.js';
const Props_DropDown = {
    module: ModuleFE_EditableTest,
    modules: [ModuleFE_EditableTest],
    mapper: item => [item.a],
    placeholder: 'Choose a EditableTest',
    renderer: item => _jsxs("div", { className: "ll_h_c", children: [" ", item.a, " "] })
};
export const DropDown_EditableTest = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_EditableTest,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsx(_Fragment, { children: item.a });
    },
    uiSelector: DropDown_EditableTest.selectable,
});
export const MultiSelect_EditableTest = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map